import { useState } from "react";
import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import CartAction from "../stores/actions/CartAction";

const AddToCart = ({
  productId,
  minSaleQty,
  cartData,
  state,
  cartStatus,
  getProductList,
}: any) => {
  const dispatch = useDispatch<any>();
  const [loader, setLoader] = useState<boolean>(false);

  const handleSubmit = async () => {
    if (cartStatus === true) {
      toast.error("Already added!");
      return false;
    }
    setLoader(true);
    try {
      await dispatch(
        CartAction.addCart({
          product_id: productId,
          qty: minSaleQty,
          state: state,
        })
      );
      await cartData();
      getProductList();
      setLoader(false);
      toast.success("Added to Cart");
    } catch (e: any) {
      setLoader(false);
      toast.error(e.message);
    }
  };

  return (
    <>
      <button
        type={"submit"}
        className={`btn ${
          cartStatus === true ? "btn-success" : "btn-primary"
        } btn-sm w-100`}
        disabled={loader}
        onClick={handleSubmit}>
        {loader ? <i className={"fa fa-spinner fa-spin"}></i> : null}
        {cartStatus === true ? "Already Added" : "Add To Cart"}
      </button>
    </>
  );
};

export default AddToCart;
